import React from "react";
import styled from 'styled-components'

const Row = styled.div`
  ${p => p.inlineStyle.height && `height: ${p.inlineStyle.height}`}

  ${ p => p.inlineCSS && p.inlineCSS};
`

export default ({ children, extra = {} }) => {
  const { style = {}, css, className = '' } = extra;

  return (
    <Row inlineStyle={style} inlineCSS={css} className={`row ${className}`}>
      {children}
    </Row>
  );
};
